import { TabsWithContent, useQueryState } from "@homebound/beam";
import { useParams } from "react-router";
import { Loading } from "src/components";
import {
  BidContractProration_RevisionQuery,
  useBidContractProration_RevisionQuery,
  useBidContractProration_ScopeLinesQuery,
} from "src/components/bid-contracts/BidContractProrationPage.generated";
import { ProrateBidView } from "src/routes/bids/components/ProrateBidModal";
import { queryResult } from "src/utils";

export function BidContractProrationPage() {
  const { bidContractRevisionId } = useParams<{ bidContractRevisionId: string }>();
  const query = useBidContractProration_RevisionQuery({ variables: { bidContractRevisionId } });
  return queryResult(query, ({ bidContractRevision }) => (
    <BidContractProrationView bidContractRevision={bidContractRevision} />
  ));
}

function BidContractProrationView({
  bidContractRevision,
}: {
  bidContractRevision: BidContractProration_RevisionQuery["bidContractRevision"];
}) {
  const bidPackageVersion = bidContractRevision.bidPackageVersion!;
  const sortedRpavs = bidPackageVersion.readyPlanAggregateVersions.sortBy((rpav) => rpav.readyPlan.id) ?? [];
  const [selectedTab, setSelectedTab] = useQueryState<string>("planId", sortedRpavs[0].readyPlan.id);
  const query = useBidContractProration_ScopeLinesQuery({
    variables: {
      bidPackageVersionId: bidPackageVersion.id,
      filter: { readyPlan: [selectedTab] },
    },
  });
  return (
    <TabsWithContent
      alwaysShowAllTabs
      tabs={sortedRpavs.map((rpav) => ({
        name: rpav.displayName,
        value: rpav.readyPlan.id,
        render: () => {
          if (query.loading) return <Loading />;
          return queryResult(query, ({ bidPackageVersionScopeLines }) => (
            <ProrateBidView
              bidContractRevisionId={bidContractRevision.id}
              scopeLineItems={bidPackageVersionScopeLines.map((sli) => sli.takeoffLineItemVersion)}
              type={bidContractRevision.bidContract.type!.code}
              existingTradeLineItems={bidContractRevision.tradeLineItems}
              prorationModalTreatment={false}
              disabled={!bidContractRevision.canEdit.allowed}
            />
          ));
        },
      }))}
      selected={selectedTab}
      onChange={setSelectedTab}
    />
  );
}
